import { render, staticRenderFns } from "./RostockLevel.vue?vue&type=template&id=f8175af8&scoped=true&"
import script from "./RostockLevel.vue?vue&type=script&lang=js&"
export * from "./RostockLevel.vue?vue&type=script&lang=js&"
import style0 from "./RostockLevel.vue?vue&type=style&index=0&id=f8175af8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8175af8",
  null
  
)

export default component.exports